<template>
  <div>
    <router-view v-show='$route.matched.length==3'></router-view>
    <PageHeaderLayout ref='artistPageHeader' v-show='$route.matched.length==2'>
      <div class='main-page-content artist-page'>
        <div class='artist-toolbar'>
          <el-form class='artist-search-form' :model='searchCondition' :inline='true' label-position='right' label-width=''>
            <el-form-item label=''>
              <CompanySelect class='artist-company-select' :multiple='true' @handleSelect='selectDept' />
            </el-form-item>
            <el-form-item label='' prop='nickname'>
              <el-input v-model='searchCondition.nickname' class='artist-nickname-search'
                        placeholder='红人昵称模糊搜索' clearable
                        @input='handleNicknameChange'
                        @clear='handleNicknameChange'
                        @keyup.enter.native='searchForm'></el-input>
            </el-form-item>
            <el-form-item label='' prop='sign_status'>
              <el-select v-model='signStatusValue' class='artist-status-select' placeholder='全部' @change='selectSignStatus'>
                <el-option label='全部' value=''></el-option>
                <el-option label='签约' value='Y'></el-option>
                <el-option label='解约' value='N'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type='primary' icon='el-icon-search' @click='searchForm'>查询</el-button>
              <el-button @click='clearCondition'>重置</el-button>
              <el-button type='text' @click='searchButton'>更多</el-button>
            </el-form-item>
          </el-form>
          <div class='artist-actions'>
            <el-button plain size='medium' icon='el-icon-s-data'
                       v-if="userPermissions.indexOf('kol_basic_record_list') !== -1"
                       @click="goToPage('artist_base')">基础数据
            </el-button>
            <el-button plain size='medium' icon='el-icon-s-custom'
                       v-if="userPermissions.indexOf('artist_compare') !== -1"
                       @click="goToPage('artist_compare')">红人对照
            </el-button>
            <el-button plain size='medium' icon='el-icon-s-check'
                       v-if="userPermissions.indexOf('trend_list') !== -1"
                       @click="goToPage('trend_enter')">涨粉录入
            </el-button>
            <el-button plain size='medium' icon='el-icon-money'
                       v-if="userPermissions.indexOf('revenue_list') !== -1"
                       @click="goToPage('revenue_enter')">营收录入
            </el-button>
          </div>
        </div>
        <!--   table列表     -->
        <div ref='artistTableSection' class='default-table artist-table-section'>
          <ApeTable
            class='artist-table'
            ref='apeTable'
            :data='dataList'
            :height='tableHeight'
            :loading='loadingStatus'
            :pagingData='pagingData'
            @switchPaging='switchPaging'
            @changeTableSort='changeTableSort'
            highlight-current-row
            border>
            <el-table-column
              slot='second-column'
              width='64'
              label='序号' align='center' fixed='left'>
              <template slot-scope='scope'>
                <span>{{ offset + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              slot='second-column'
              width='120'
              label='操作' align='center' fixed='left'>
              <template slot-scope='scope'>
                <span>
                  <el-tooltip effect='dark' content='编辑' placement='top-start'
                              v-if="userPermissions.indexOf('artist_edit') != -1">
                    <el-link type='primary' size='mini' icon='el-icon-edit'
                             @click='editButton(scope.row.id)'>编辑</el-link>
                  </el-tooltip>
                </span>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='nickname' label='红人昵称' min-width='120' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <artist-nickname :info='{artist_id:row.id,nickname:row.nickname}' />
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='group_id' label='项目组' min-width='120' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <span>{{ row.group_name || row.group_id }}</span>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='_platform' label='数据平台' min-width='120'
                             header-align='center' align='left'
                             show-overflow-tooltip
            >
              <template slot-scope='{row}'>
                <el-tooltip effect='dark' :content='getPlatformTooltip(row._platform)' placement='top'
                            :disabled='getHiddenPlatformCount(row._platform) === 0'>
                  <span class='platform-tags'>
                    <el-tag v-for='(item,index) in getVisiblePlatforms(row._platform)' :key='item + index'
                            size='mini' effect='plain'>{{ item }}
                    </el-tag>
                    <el-tag v-if='getHiddenPlatformCount(row._platform) > 0' class='platform-more-tag'
                            size='mini' effect='plain'>+{{ getHiddenPlatformCount(row._platform) }}
                    </el-tag>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='_journal' label='刊例平台' min-width='120'
                             header-align='center' align='left'
                             show-overflow-tooltip
            >
              <template slot-scope='{row}'>
                <el-tooltip effect='dark' :content='getPlatformTooltip(row._journal)' placement='top'
                            :disabled='getHiddenPlatformCount(row._journal) === 0'>
                  <span class='platform-tags'>
                    <el-tag v-for='(item,index) in getVisiblePlatforms(row._journal)' :key='item + index'
                            size='mini' effect='plain'>{{ item }}
                    </el-tag>
                    <el-tag v-if='getHiddenPlatformCount(row._journal) > 0' class='platform-more-tag'
                            size='mini' effect='plain'>+{{ getHiddenPlatformCount(row._journal) }}
                    </el-tag>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='sign_status' label='签约状态' min-width='100' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <el-tag class='sign-status-tag' :class="row.sign_status === 'Y' ? 'is-signed' : 'is-fired'"
                        size='mini' effect='plain'>{{ row.sign_status_alias }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='sign_start' label='签约日期' min-width='100' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <span>{{ row.sign_start }}</span>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='sign_end' label='合约到期' min-width='100' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <span>{{ row.sign_end }}</span>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='fired_at' label='解约日期' min-width='100' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <span>{{ row.fired_at }}</span>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='group_time' label='入组日期' min-width='100' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <span>{{ row.group_time }}</span>
              </template>
            </el-table-column>
            <el-table-column slot='second-column' prop='updated_at' label='修改时间' min-width='100' align='center'
                             show-overflow-tooltip
                             sortable='custom'>
              <template slot-scope='{row}'>
                <span>{{ row.updated_at }}</span>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
        <!--   抽屉查询     -->
        <ApeDrawer :drawerData='drawerData' @drawerClose='drawerClose' @drawerConfirm='drawerConfirm'>
          <template slot='ape-drawer'>
            <el-form :model='searchCondition' ref='userForm' label-position='right' label-width='96px'>
              <el-row>
                <el-col :span='22'>
                  <el-form-item label='平台'>
                    <el-checkbox-group v-model='searchCondition.platforms'>
                      <el-checkbox v-for='item in platforms' :label='item.code' :value='item.code' :key='item.code'>
                        {{ item.name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label='平台ID'>
                    <el-input placeholder='请输入平台ID' style='width: 200px'
                              v-model='searchCondition.platforms_account_id'
                              oninput="value=value.replace(/^\s*|\s*$/g,'')" clearable />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='22'>
                  <el-form-item label='分组'>
                    <CompanySelect ref='refDeptCascader' :multiple='true'
                                   @handleSelect='selectDept($event,"cascader")' />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='22'>
                  <el-form-item label='签约状态' prop='status'>
                    <el-checkbox-group v-model='searchCondition.sign_status'>
                      <el-checkbox label='Y'>签约</el-checkbox>
                      <el-checkbox label='N'>解约</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='22'>
                  <el-form-item label='红人昵称' prop='email'>
                    <el-input v-model='searchCondition.nickname' placeholder='红人昵称模糊匹配' clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span='22'>
                  <el-form-item>
                    <el-button type='primary' @click='searchForm'>筛选</el-button>
                    <el-button @click='clearCondition'>全部清除</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template>
        </ApeDrawer>

      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'

export default {
  name: 'ArtistList',
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer
  },
  data() {
    return {
      orderSort: { id: 'desc' },//默认排序规则
      loadingStatus: true,
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20
      },
      // 分页的offset,序号列使用
      offset: 0,
      tableHeight: 420,
      columns: [],
      platforms: [],
      signStatusValue: 'Y',
      nicknameSearchTimer: null,
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        width_height: '480px',
        show_footer: false
      },
      searchCondition: {
        nickname: null,
        sign_status: ['Y'],
        platforms: [],
        platforms_account_code: null,
        platforms_account_id: null
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  created() {
    // 平台
    // console.log(this.$route.matched)
    if (this.$route.matched.length === 2) {
      this.init()
    }
  },
  mounted() {
    this.setArtistPageContentClass(this.$route.matched.length === 2)
    this.$nextTick(this.setTableHeight)
    window.addEventListener('resize', this.setTableHeight)
  },
  beforeDestroy() {
    this.setArtistPageContentClass(false)
    window.removeEventListener('resize', this.setTableHeight)
    if (this.nicknameSearchTimer) {
      clearTimeout(this.nicknameSearchTimer)
    }
  },
  watch: {
    '$route.matched': function(n) {
      this.setArtistPageContentClass(n.length === 2)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    setArtistPageContentClass(active) {
      const pageHeader = this.$refs['artistPageHeader']
      const pageContent = pageHeader && pageHeader.$el
        ? pageHeader.$el.querySelector('.page-content')
        : null
      if (pageContent) {
        pageContent.classList.toggle('artist-list-page-content', active)
      }
    },
    init() {
      this.getColumns()
      this.getPlatforms()
      setTimeout(() => {
        this.initList()
      }, 800)

    },
    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.initList()
    },
    goToPage(routeName) {
      // this.$router.push({ path: routeName })
      this.$router.push({ name: routeName })
    },
    formatPlatformList(value) {
      if (!value) {
        return []
      }
      if (Array.isArray(value)) {
        return value.map(item => {
          if (typeof item === 'string') {
            return item
          }
          return item.name || item.platform_name || item.label || item.title || item.code || ''
        }).filter(Boolean)
      }
      const text = String(value)
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
      return text.split(/[\s,，、;；/|]+/)
        .map(item => item.trim())
        .filter(item => item && !/^\+\d+$/.test(item))
    },
    getSourceHiddenPlatformCount(value) {
      if (typeof value !== 'string') {
        return null
      }
      const result = value.match(/\+(\d+)/)
      return result ? Number(result[1]) : null
    },
    getVisiblePlatforms(value) {
      return this.formatPlatformList(value).slice(0, 2)
    },
    getHiddenPlatformCount(value) {
      const sourceHiddenCount = this.getSourceHiddenPlatformCount(value)
      if (sourceHiddenCount !== null) {
        return sourceHiddenCount
      }
      return Math.max(this.formatPlatformList(value).length - 2, 0)
    },
    getPlatformTooltip(value) {
      const platformList = this.formatPlatformList(value)
      const hiddenCount = this.getHiddenPlatformCount(value)
      if (hiddenCount > 0 && platformList.length <= 2) {
        return `${platformList.join('、')}，另有${hiddenCount}个`
      }
      return platformList.join('、')
    },
    setTableHeight() {
      const section = this.$refs['artistTableSection']
      if (!section) {
        return
      }
      const pagination = section.querySelector('.el-pagination')
      const paginationHeight = pagination ? pagination.offsetHeight + 24 : 44
      const sectionStyle = window.getComputedStyle(section)
      const sectionPadding = parseFloat(sectionStyle.paddingTop) + parseFloat(sectionStyle.paddingBottom)
      this.tableHeight = Math.max(section.clientHeight - paginationHeight - sectionPadding, 260)
    },
    async getColumns() {
      const { columns } = await this.$api.getColumnsArtist()
      this.columns = columns
    },
    async getPlatforms() {
      //从缓存中读取上次的平台信息
      // let platformsJson = localStorage.getItem('platforms')
      // if (platformsJson) {
      //   this.platforms = JSON.parse(platformsJson)
      // }
      // 获取最新平台信息
      const { list } = await this.$api.getPlatforms()
      this.platforms = list
      // 缓存平台信息
      localStorage.setItem('platforms', JSON.stringify(list))


    },
    // 初始化列表
    async initList(type) {
      this.loadingStatus = true
      const pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      const searchCondition = this.handleSearchCondition()
      // Object.assign(searchCondition, pagingInfo)
      Object.assign(searchCondition, pagingInfo, { order: this.orderSort })
      this.dataList = []
      const { list, pages } = await this.$api.getArtistList(searchCondition)
      this.$nextTick(() => {
        this.dataList = list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStatus = false
      this.$nextTick(this.setTableHeight)
    },
    // 切换页码操作
    async switchPaging() {
      await this.initList()
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.platforms) {
        condition.platforms = this.searchCondition.platforms
      }
      if (this.searchCondition.nickname) {
        condition.nickname = this.searchCondition.nickname
      }
      if (this.searchCondition.platforms_account_code) {
        condition.platforms_account_code = this.searchCondition.platforms_account_code
      }
      if (this.searchCondition.platforms_account_id) {
        condition.platforms_account_id = this.searchCondition.platforms_account_id
      }
      if (this.searchCondition.sign_status.length > 0) {
        condition.sign_status = this.searchCondition.sign_status
      }

      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      if (this.searchCondition.group_range?.length != 0) {
        condition.group_range = this.searchCondition.group_range
      }

      return condition
    },
    searchButton() {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '查询条件'
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 响应添加按钮
    addButton() {
      this.$router.push({
        path: this.$route.path + '/create'
      })
    },
    // 响应编辑按钮
    detailButton(id) {
      this.$router.push(this.$route.path + '/' + id + '/intro')
    },
    // 响应编辑按钮
    editButton(id) {
      this.$router.push(this.$route.path + '/' + id + '/edit')
    },
    selectSignStatus(val) {
      this.searchCondition.sign_status = val ? [val] : []
      this.searchForm()
    },
    handleNicknameChange() {
      if (this.nicknameSearchTimer) {
        clearTimeout(this.nicknameSearchTimer)
      }
      this.nicknameSearchTimer = setTimeout(() => {
        this.searchForm()
      }, 300)
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
    },
    // 处理抽屉确认
    async drawerConfirm() {
      this.searchForm()
    },
    // 搜索
    searchForm() {
      this.drawerData.visible = false
      this.offset = 0
      this.initList()
      // this.$refs['apeTable'].handleCurrentChange(1)
    },
    clearCondition() {
      this.signStatusValue = 'Y'
      this.searchCondition = {
        nickname: null,
        sign_status: ['Y'],
        group_range: [],
        platforms: [],
        platforms_account_code: null,
        platforms_account_id: null
      }
      this.searchForm()
    },
    async selectDept(val, type = null) {
      this.searchCondition.group_range = val
      if (!type) {
        this.searchForm()
      }
    }

  }
}
</script>

<style lang='scss' scoped>
.main-page-content.artist-page {
  height: calc(100vh - 72px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  padding: 12px 16px 0;
  background: #f5f6f8;
}

.main-page-content.artist-page > .artist-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(30, 41, 59, .04);
}

.artist-search-form {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.artist-actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.main-page-content.artist-page > .artist-table-section {
  flex: 1;
  min-height: 0;
  padding: 8px 10px 0;
  box-sizing: border-box;
  background: #fff;
}

.artist-table {
  height: 100%;
}

.platform-tags {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 22px;
  white-space: nowrap;
}

.platform-tags .el-tag {
  height: 22px;
  padding: 0 6px;
  line-height: 20px;
  color: #2b3445;
  background: #fff;
  border-color: #aeb7c2;
}

.platform-tags .platform-more-tag {
  color: #ff3176;
  background: #fff2f7;
  border-color: #ffc1d5;
}

.sign-status-tag {
  min-width: 42px;
  height: 22px;
  line-height: 20px;
}

.sign-status-tag.is-signed {
  color: #17a66a;
  background: #e9f8f1;
  border-color: #d5f0e4;
}

.sign-status-tag.is-fired {
  color: #ff3176;
  background: #fff2f7;
  border-color: #ffd6e4;
}

.artist-table-section ::v-deep .el-pagination {
  margin-top: 12px;
  padding-bottom: 0;
  line-height: 28px;
}

.artist-table-section ::v-deep .el-pagination__total,
.artist-table-section ::v-deep .el-pagination__sizes,
.artist-table-section ::v-deep .el-pagination__jump {
  height: 28px;
  line-height: 28px;
}

.artist-table-section ::v-deep .el-pagination.is-background .btn-prev,
.artist-table-section ::v-deep .el-pagination.is-background .btn-next,
.artist-table-section ::v-deep .el-pagination.is-background .el-pager li {
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  margin: 0 3px;
}

.artist-table-section ::v-deep .el-pagination .el-input__inner {
  height: 28px;
  line-height: 28px;
}

.artist-status-select {
  width: 112px;
}

.artist-nickname-search {
  width: 220px;
}

.artist-toolbar ::v-deep .el-form-item {
  margin: 0;
}

.artist-toolbar ::v-deep .el-form-item__content {
  line-height: 32px;
}

.artist-company-select ::v-deep .el-cascader {
  width: 320px !important;
}

.artist-toolbar ::v-deep .el-input__inner,
.artist-toolbar ::v-deep .el-button {
  height: 32px;
  line-height: 30px;
}

.artist-toolbar ::v-deep .el-button {
  padding: 0 14px;
}

.artist-toolbar ::v-deep .el-button--primary {
  background-color: #ff3176;
  border-color: #ff3176;
}

.artist-toolbar ::v-deep .el-button--primary:hover,
.artist-toolbar ::v-deep .el-button--primary:focus {
  background-color: #ff5c92;
  border-color: #ff5c92;
}

.artist-actions ::v-deep .el-button {
  margin: 0;
  color: #ff3176;
  background: #fff;
  border-color: #ff9cbd;
}

.artist-actions ::v-deep .el-button:hover,
.artist-actions ::v-deep .el-button:focus {
  color: #ff3176;
  background: #fff4f8;
  border-color: #ff3176;
}

@media (max-width: 1180px) {
  .main-page-content.artist-page > .artist-toolbar {
    flex-direction: column;
  }

  .artist-actions {
    justify-content: flex-start;
  }
}
</style>

<style lang='scss'>
.page-content.artist-list-page-content {
  overflow-y: hidden;
}

.page-content.artist-list-page-content::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>
